import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import useBusinessSizes from 'components/Common/BusinessSizes/Hooks/useBusinessSizes';
import useIndustries from 'components/Common/Industries/Hooks/useIndustries';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Managers/Profile/Actions';

const transformValues = (enterpriseId, values) => ({
  enterprise_attributes: {
    name: values.company,
    website: values.website,
    company_size_id: values.size,
    industry_ids: ['', ...values.industries],
    id: enterpriseId,
  },
});

export default function Company({ onCloseClick }) {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const manager = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
    company: Yup.string().required('Company is required'),
  });

  const { businessSizes } = useBusinessSizes();
  const { industries } = useIndustries();

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      manager.id,
      transformValues(manager.enterprise_id, values),
      false,
      () => {
        setSubmitting(false);
        onCloseClick();
        actionsUsers.load(dispatchUsers);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        company: manager.enterprise_name,
        website: manager.enterprise_website,
        size: manager.team_size_id,
        industries: manager.industry_ids.map((el) => el.toString()),
      }}
      onSubmit={onSubmitHundler}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <Row>
            <Col>
              <HorizontalTextField name="company" label="Company" required />
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <HorizontalSelectField
                name="size"
                label="Size"
                placeholder={businessSizes === null ? 'Loading...' : 'Select Size'}
                options={businessSizes === null ? [] : businessSizes.map((el) => ({
                  label: el.attributes.title,
                  value: el.id,
                }))}
              />
            </Col>

            <Col lg={6}>
              <HorizontalSelectField
                name="industries"
                label="Industry"
                isMulti
                placeholder={industries === null ? 'Loading...' : 'Select Industries'}
                options={industries === null ? [] : industries.map((el) => ({
                  label: el.attributes.title,
                  value: el.id,
                }))}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <HorizontalTextField name="website" label="Company Website" />
            </Col>
          </Row>

          <Footer loading={isSubmitting} onCancel={() => onCloseClick()} />
        </FormikForm>
      )}
    </Formik>
  );
}

Company.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
};
